import { reportError } from "@/core/lib/datadog/datadog";
import { AddressData, isApiError } from "@/core/types/types";
import { fetchWithTimeout, processApiResponse } from "@/core/utils";
import { AddressNotFoundError, GetAddressesError } from "./errors";
import { isEmpty } from "lodash";

const fetchOptions: object = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const getAddresses = async (
  search: string = ""
): Promise<{
  results: AddressData[];
  message?: string;
}> => {
  try {
    const url = "api/MIE/getAddresses?" + new URLSearchParams({ search });

    const response: Response = await fetchWithTimeout(url, {
      ...fetchOptions,
      method: "GET",
    });

    const { results } = await processApiResponse(response);

    if (isEmpty(results)) {
      const error = new AddressNotFoundError({ url, search });
      reportError(error, error.data);
    }

    return { results };
  } catch (error: any) {
    if (isApiError(error)) {
      const getAddressesError = new GetAddressesError({
        url: error.url,
        status: error.status,
        statusText: error.statusText,
        data: { search },
      });

      reportError(getAddressesError, getAddressesError.data);
    }

    throw error;
  }
};
